import { createContext, useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import type { Me } from '@berytus/contracts';
import { api, HttpError } from '../api.ts';

const MeContext = createContext<Me | null>(null);

export function useMe(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error('useMe fora do AuthGate');
  return me;
}

/** Só mostra as rotas internas para quem tem sessão; senão, manda para o login. */
export function AuthGate() {
  const location = useLocation();
  const me = useQuery({ queryKey: ['me'], queryFn: () => api<Me>('/auth/me') });

  if (me.isPending) return <div className="empty">Carregando…</div>;
  if (me.error instanceof HttpError && me.error.status === 401) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (me.error) return <div className="empty"><b>Não foi possível conectar à API.</b>Confira se ela está rodando e recarregue a página.</div>;

  return (
    <MeContext.Provider value={me.data}>
      <Outlet />
    </MeContext.Provider>
  );
}
